<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import axios from "axios";
import Swal from "sweetalert2";
import Dropdown from 'primevue/dropdown';
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
  name: "index-exams",
  inject: {
    courseCtx: { default: null },
  },
  data() {
    return {
      gradeSlug: this.$route.params.gradeSlug,
      courseId: this.$route.params.courseId ?? null,
      exams: [],
      lesson: null,
      lessons: [],
      chapter: null,
      chapters: [],
    };
  },
  components: {
    Breadcrumb,
    Dropdown
  },
  computed: {
    isCourseScope() { return !!this.courseId; },
    basePath() {
      return this.isCourseScope ? `/courses/${this.courseId}/exams` : `/${this.gradeSlug}/exams`;
    },
    addPath() {
      return this.isCourseScope ? `${this.basePath}/add` : `/${this.gradeSlug}/exam/add`;
    },
    breadcrumbs() {
      if (this.isCourseScope) {
        const base = this.courseCtx?.breadcrumbBase ?? [];
        return [...base, { name: "الامتحانات", path: this.basePath }];
      }
      return [
        { name: 'الرئيسية', path: '/' },
        { name: "الامتحانات", path: this.basePath },
      ];
    },
    gradeStore() { return useGradeStore(); },
    resolvedGrade() {
      const slug = this.gradeSlug;
      return this.gradeStore.activeGrades.find(g => g.slug === slug)
          || this.gradeStore.allGrades.find(g => g.slug === slug)
          || null;
    },
    gradeId() { return this.resolvedGrade?.id ?? null; },
  },
  methods: {
    fetchQuestions() {
      const params = this.isCourseScope ? { course_id: this.courseId } : { academic_year_id: this.gradeId };
      if (this.lesson?.id) {
        params.lesson_id = this.lesson.id;
      }

      axios
          .get('/exams', { params })
          .then((response) => {
            this.exams = response.data.data;
            // this.paggination = response.data.data.meta.total;
          })
          .catch((error) => {
            this.exams = [];
          });
    },

    deleteQuestion(exam_id) {
      Swal.fire({
        title: "هل تريد الحذف ؟",
        text: "سيتم الحذف نهائيا",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "رجوع",
        confirmButtonText: "احذف",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
              .delete(`exams/${exam_id}`)
              .then(({ data }) => {
                if (data.status == true) {
                  Swal.fire("تم الحذف بنجاح", "", "success");
                  this.exams = this.exams.filter(r => r.id !== exam_id);
                } else {
                  Swal.fire("", data.message, "error");
                }
              });
        }
      });
    },

    fetchChapters() {
      const params = this.isCourseScope
          ? { type: 2, course_id: this.courseId }
          : { type: 2, academic_year_id: this.gradeId };
      return axios
          .get('/lessons', { params })
          .then((response) => { this.chapters = response.data.data; })
          .catch(() => {});
    },
    fetchLessons() {
      const chapterId = this.chapter?.id;
      const params = this.isCourseScope
          ? { type: 3, course_id: this.courseId, parent_id: chapterId }
          : { type: 3, academic_year_id: this.gradeId, parent_id: chapterId };
      return axios
          .get('/lessons', { params })
          .then((response) => { this.lessons = response.data.data; })
          .catch(() => {});
    },

    customLabelChapter(option) {
      return option ? (option.description ? `${option.title} (${option.description})` : option.title) : '';
    },
    customLabelLesson(option) {
      return option ? (option.description ? `${option.title} (${option.description})` : option.title) : '';
    },
  },
  async mounted() {
    if (!this.isCourseScope) {
      if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
      if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
    }
    await this.fetchChapters();
    const lessonId = this.$route.query.lesson_id;
    if (lessonId) {
      for (const chapter of this.chapters) {
        this.chapter = chapter;
        await this.fetchLessons();
        const match = this.lessons.find(l => String(l.id) === String(lessonId));
        if (match) { this.lesson = match; break; }
        this.chapter = null;
      }
    }
    this.fetchQuestions();
  }
}
</script>

<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="container-fluid my-3">
    <div class="filter my-3">
      <div class="filter-head">
        <div class="row d-flex align-items-center gap-4 w-75">
          <h4 class="mb-0 col-lg-2 col-12">الامتحانات</h4>
          <div class="row d-flex gap-lg-0 gap-2 col-lg-10 col-12 mb-lg-0 mb-2">
            <div class="col-lg-4 col-md-6 col-12">
              <div class="d-flex flex-column gap-2">
                <Dropdown v-model="chapter" :options="chapters" showClear :optionLabel="customLabelChapter" placeholder="اختر الباب" class="w-full md:w-14rem" @update:model-value="fetchLessons" />
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12">
              <div class="d-flex flex-column gap-2">
                <Dropdown v-model="lesson" :options="lessons" showClear :optionLabel="customLabelLesson" placeholder="اختر الدرس" class="w-full md:w-14rem" @update:model-value="fetchQuestions" />
              </div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <router-link :to="addPath" class="btn PrimaryButton">إضافة امتحان</router-link>
        </div>
      </div>
    </div>
    <div class="row reservation-table">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">الصورة</th>
              <th scope="col">العنوان</th>
              <th scope="col">التاريخ</th>
              <th scope="col">درجة الامتحان</th>
              <th scope="col">صعوبة السؤال</th>
              <th scope="col">الدرس</th>
              <th scope="col">التحكم</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(exam, index) in exams"
                :key="exam.id"
            >
              <td data-label="ID">{{ index + 1 }}</td>
              <td data-label="الصورة">
                <img v-if="exam.image" :src="exam.image" alt="exam Image" style="width: 50px; height: 50px; object-fit: cover; border-radius: 5px;" />
                <span v-else>--- </span>
              </td>
              <td data-label="الاسم">{{ exam.title }}</td>
              <td data-label="التاريخ">{{ exam.date }}</td>
              <td data-label=">درجة الامتحان">{{ exam.total_degree }}</td>
              <td data-label="صعوبة السؤال">
                <span v-if="exam.difficulty_level === 'easy'">سهل</span>
                <span v-else-if="exam.difficulty_level === 'medium'">متوسط</span>
                <span v-else-if="exam.difficulty_level === 'hard'">صعب</span>
              </td>
              <td data-label="الدرس">{{ exam.lesson ? exam.lesson?.title : '---' }}</td>
              <td data-label="التحكم">
                <router-link class="btn btn-success text-white mx-1"
                             :tooltip="'تقارير الامتحان'"
                             flow="up"
                             :to="isCourseScope ? `${basePath}/${exam.id}/report` : `/${gradeSlug}/exam/${exam.id}/report`">
                  <i class="pi pi-chart-bar"></i>
                </router-link>
                <router-link class="btn btn-primary text-white mx-1"
                             :tooltip="'تعديل'"
                             flow="up"
                             :to="isCourseScope ? `${basePath}/edit/${exam.id}` : `/${gradeSlug}/exam/edit/${exam.id}`">
                  <i class="pi pi-pencil"></i>
                </router-link>
                <button class="btn btn-danger text-white mx-1"
                        type="button"
                        :tooltip="`حذف`"
                        flow="up"
                        @click="deleteQuestion(exam.id)">
                  <i class="pi pi-trash"></i>
                </button>
              </td>
            </tr>
            <tr v-if="exams.length === 0">
              <td colspan="8" class="text-center">لا يوجد بيانات</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
